import settings from '@/settings';

export const CART_COOKIE_NAME = `${settings.store}-cart-id`;
